/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Driver_Remittance_No_PaymentsInputs */

const vi_error_driver_remittance_no_payments = /** @type {(inputs: Error_Driver_Remittance_No_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tick ít nhất một đơn tài xế đã đưa tiền.`)
};

/**

* @param {Error_Driver_Remittance_No_PaymentsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_driver_remittance_no_payments = /** @type {((inputs?: Error_Driver_Remittance_No_PaymentsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Driver_Remittance_No_PaymentsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_driver_remittance_no_payments(inputs)
});